import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { LineItemUpsell } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';
import { useSessionStorage } from '@grandvisionhq/utils';
import '../../../context/Cart/context.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';
import '../../../utils/cart-count-var.js';
import '../../../utils/cart-id-var.js';
import '@grandvisionhq/commercetools';
import '../../../utils/get-unrecoverable-validation-errors.js';
import '../../../models/line-item/prescription-glasses.js';
import '../../../utils/get-failure-error-codes.js';
import '../../../utils/get-validation-errors-by-line-item.js';
import '../../../operations/fragments/cart-details.js';
import '../../../operations/fragments/cart-validation-errors.js';
import '../../../operations/fragments/recover-inactive-cart-failure.js';
import '../../../operations/fragments/recover-inactive-cart-result.js';
import '../../../operations/mutations/add-cart-line-items.js';
import '../../../operations/mutations/add-cart-voucher-codes.js';
import '../../../operations/mutations/create-cart.js';
import '../../../operations/mutations/create-cart-from-instant-checkout-link.js';
import '../../../operations/mutations/create-cart-from-order.js';
import '../../../operations/mutations/duplicate-cart-line-items.js';
import '../../../operations/mutations/remove-cart-voucher-codes.js';
import '../../../operations/mutations/remove-cart-line-items.js';
import '../../../operations/mutations/update-cart-line-items.js';
import '../../../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../../../operations/mutations/recover-inactive-cart.js';
import '../../../operations/queries/get-cart.js';
import '../../../operations/queries/get-total-line-items.js';
import '../../../operations/queries/get-cart-estimated-delivery.js';
import { useCartSettings } from '../../../context/CartSettings/context.js';
import { useAddToCart } from '../../../hooks/use-add-to-cart.js';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/payments';
import '../../../mappers/analytics/tealium/line-item-to-tealium-product.js';

const Insurance = ({ visualLineItem , handleOpenModal  })=>{
    const intl = useIntl();
    const settings = useCartSettings();
    const [addToCart] = useAddToCart();
    const [consent, setConsent] = useSessionStorage(`insurance_terms_and_conditions-${visualLineItem.id}`, undefined, (value)=>!value
    );
    const insuranceLabels = React.useMemo(()=>({
            add: intl.getLabel('common.add'),
            free: intl.getLabel('common.free'),
            title: intl.getLabel('cart.insurance.title'),
            consent: intl.getLabel('cart.insurance.consent.conditions'),
            uspList: [
                intl.getLabel('cart.insurance.usp1', {
                    hideLabelKey: true
                }),
                intl.getLabel('cart.insurance.usp2', {
                    hideLabelKey: true
                }), 
            ].filter(Boolean),
            moreAbout: intl.getLabel('cart.insurance.moreAboutCoverage'),
            implicitTermsAndAgreementLabel: intl.getFormattedLabel('cart.insurance.implicitTermsAndAgreementLabel', {
                parseLink: true,
                openLinksInNewTab: true
            }),
            explicitTermsAndAgreementLabel: intl.getFormattedLabel('cart.insurance.explicitTermsAndAgreementLabel', {
                parseLink: true,
                openLinksInNewTab: true
            }),
            errorMessage: intl.getLabel('common.form.field.requiredError')
        })
    , [
        intl
    ]);
    if (!visualLineItem.eligibleInsurance) {
        return null;
    }
    const onError = (errorCodes)=>errorCodes.forEach((code)=>toast.failed(`cart.${code}`)
        )
    ;
    const handleAddToCart = ()=>{
        const { eligibleInsurance  } = visualLineItem;
        if (!eligibleInsurance) {
            return;
        }
        const itemDraft = {
            sku: eligibleInsurance.sku,
            quantity: 1,
            type: 'insurance',
            typeDetails: {
                lineItemId: visualLineItem.id
            }
        };
        addToCart([
            itemDraft
        ], undefined, onError, (e)=>onError([
                e
            ])
        );
    };
    const handleTermsAndConditionsChange = (checked)=>{
        setConsent(checked);
    };
    return /*#__PURE__*/ React.createElement(LineItemUpsell, {
        sku: visualLineItem.eligibleInsurance.sku,
        labels: insuranceLabels,
        currency: intl.currency,
        value: visualLineItem.eligibleInsurance.price.subtotal,
        showImplicitTermsAndConditions: settings.showInsuranceImplicitTermsAndConditions,
        handleOpenModal: handleOpenModal,
        handleAddToCart: handleAddToCart,
        onTermsAndConditionsChange: handleTermsAndConditionsChange,
        isChecked: consent,
        errorMessageKey: 'cart.insurance.error.required'
    });
};

export { Insurance };
//# sourceMappingURL=Insurance.js.map
